import { createAction, props } from '@ngrx/store';
import type {
  AnswerChannelMeetingPayload,
  ChannelMeetingStatus,
  ChannelMeetingStatusPayload,
  ChannelMeetingSession,
  DeclineChannelMeetingPayload,
  EndChannelMeetingPayload,
  IncomingCallSignal,
  JoinChannelMeetingPayload,
  MeetingLaunchSignal,
  StartChannelMeetingPayload,
} from './meeting.models';

export const MeetingStartChannelRequest = createAction(
  '[Meeting] Start Channel Request',
  props<{ payload: StartChannelMeetingPayload }>()
);

export const MeetingStartChannelSuccess = createAction(
  '[Meeting] Start Channel Success',
  props<{ session: ChannelMeetingSession; message: string }>()
);

export const MeetingStartChannelFailure = createAction(
  '[Meeting] Start Channel Failure',
  props<{ error: string }>()
);

export const MeetingAnswerChannelRequest = createAction(
  '[Meeting] Answer Channel Request',
  props<{ payload: AnswerChannelMeetingPayload }>()
);

export const MeetingAnswerChannelSuccess = createAction(
  '[Meeting] Answer Channel Success',
  props<{ session: ChannelMeetingSession; message: string }>()
);

export const MeetingAnswerChannelFailure = createAction(
  '[Meeting] Answer Channel Failure',
  props<{ error: string }>()
);

export const MeetingJoinChannelRequest = createAction(
  '[Meeting] Join Channel Request',
  props<{ payload: JoinChannelMeetingPayload }>()
);

export const MeetingJoinChannelSuccess = createAction(
  '[Meeting] Join Channel Success',
  props<{ session: ChannelMeetingSession; message: string }>()
);

export const MeetingJoinChannelFailure = createAction(
  '[Meeting] Join Channel Failure',
  props<{ error: string }>()
);

export const MeetingGetChannelStatusRequest = createAction(
  '[Meeting] Get Channel Status Request',
  props<{ payload: ChannelMeetingStatusPayload }>()
);

export const MeetingGetChannelStatusSuccess = createAction(
  '[Meeting] Get Channel Status Success',
  props<{ status: ChannelMeetingStatus }>()
);

export const MeetingGetChannelStatusFailure = createAction(
  '[Meeting] Get Channel Status Failure',
  props<{ channelId: string; error: string }>()
);

export const MeetingDeclineChannelRequest = createAction(
  '[Meeting] Decline Channel Request',
  props<{ payload: DeclineChannelMeetingPayload }>()
);

export const MeetingDeclineChannelSuccess = createAction(
  '[Meeting] Decline Channel Success',
  props<{ channelId: string; message: string }>()
);

export const MeetingDeclineChannelFailure = createAction(
  '[Meeting] Decline Channel Failure',
  props<{ error: string }>()
);

export const MeetingEndChannelRequest = createAction(
  '[Meeting] End Channel Request',
  props<{ payload: EndChannelMeetingPayload }>()
);

export const MeetingEndChannelSuccess = createAction(
  '[Meeting] End Channel Success',
  props<{ channelId: string; message: string }>()
);

export const MeetingEndChannelFailure = createAction(
  '[Meeting] End Channel Failure',
  props<{ error: string }>()
);

export const MeetingReceiveIncomingCall = createAction(
  '[Meeting] Receive Incoming Call',
  props<{ incomingCall: IncomingCallSignal }>()
);

export const MeetingDismissIncomingCall = createAction(
  '[Meeting] Dismiss Incoming Call'
);

export const MeetingReceiveLaunchSignal = createAction(
  '[Meeting] Receive Launch Signal',
  props<{ launch: MeetingLaunchSignal }>()
);

export const MeetingReceiveDeclineSignal = createAction(
  '[Meeting] Receive Decline Signal',
  props<{ channelId: string }>()
);

export const MeetingReceiveEndSignal = createAction(
  '[Meeting] Receive End Signal',
  props<{ channelId: string }>()
);
